import "mapbox-gl/dist/mapbox-gl.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PageContainer from "../../components/PageContainer";
import { message, Skeleton } from "antd";
import { AimOutlined } from "@ant-design/icons";
import ReactMapGL, { Marker } from "react-map-gl";
import { setRTLTextPlugin } from "mapbox-gl";
import Markers from "./Markers";
import {
  getNormalizeObj,
  checkValue,
  hasOwnNestedProperty,
} from "../../constant/helper";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import SearchResults from "./SearchResult";
import LBSSearch from "./LBSSearch";
import { getContentService } from "../wiki/wiki.api";
import { getLocationsService } from "./LBS.api";
import MarkerInfo from "./markerInfo/Info";
import Pinned from "../../images/lbs/active-pin.svg";
import BottomSheet from "../../components/BottomSheet";
import ShowGpsInfo from "./components/ShowGpsInfo";
import Icon1 from "./images/1.png";
import Icon2 from "./images/2.png";
import Icon3 from "./images/3.png";
import Icon4 from "./images/4.png";
import Icon5 from "./images/5.png";
import Icon6 from "./images/6.png";
import Icon7 from "./images/7.png";

const token = process.env.REACT_APP_MAPBOX_API_KEY;

setRTLTextPlugin("/mapbox-gl-rtl-text.js", null, true);

const pixelMeterSizes = {
  10: 1 / 10,
  11: 1 / 9,
  12: 1 / 8,
  13: 1 / 7,
  14: 1 / 5,
  15: 1 / 4.773,
  16: 1 / 2.387,
  17: 1 / 1.193,
  18: 1 / 0.596,
  19: 1 / 0.398,
  20: 1 / 0.398,
  21: 1 / 0.398,
  22: 1 / 0.398,
};

const LBS = () => {
  const mapRef = useRef();
  const [showGpsInfo, setShowGpsInfo] = useState(false);
  const [mapServiceTimeout, setMapServiceTimeout] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pinLoading, setPinLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [pin, setPin] = useState("");
  const [pinData, setPinData] = useState({
    id: "5fa6c5f50920e229e78e2948",
    title: {
      type: "string",
      fields: ["دفاتر ثبت ازدواج و طلاق"],
    },
    banner: {
      type: "string",
      fields: [""],
    },
    summary: {
      type: "string",
      fields: [
        "دفاتر ازدواج و طلاق از نهادهای تخصصی مدنی هستند که بخشی از وظایف اجرایی سازمان ثبت اسناد و املاک کشور را انجام می‌دهند. این دفاتر از نظر مالیمستقل هستند و به‌طور خصوصی اداره می‌شوند؛ ولی سازمان ثبت اسناد و املاککشور سردفتران (مدیران دفاتر) را گزینش می‌کند قوانین این دفاتر را تنظیم و ابلاغ می‌کند و بر عملکرد این دفاتر نظارت می‌کند قبل از ثبت ازدواج، زوجین باید آزمایش‌هایی نظیر اعتیاد و تالاسمی را انجام دهند. برای انجام آزمایش باید به دفتر ازدواج مراجعه کنند تا برای مراجعه به آزمایش‌گاه، معرفی‌نامه دریافت کنند. پس از دریافت معرفی‌نامه، زوجین می‌توانند به هریک از آزمایش‌گاه‌های اعلام شده توسط سازمان ثبت اسناد و املاک کشور مراجعه کنند. پس از دریافت نتایج آزمایش‌ها زوجین می‌توانند برای ثبت ازدواج به دفتر ازدواج مراجعه کنند.",
      ],
    },
    language: "FA",
    type: "lbs",
    content: [
      {
        type: "string",
        fields: [
          "مدارک مورد نیاز برای طلاق",
          "دفاتر ازدواج و طلاق از نهادهای تخصصی مدنی هستند که بخشی از وظایف اجرایی سازمان ثبت اسناد و املاک کشور را انجام می‌دهند. این دفاتر از نظر مالی مستقل هستند و به‌طور خصوصی اداره می‌شوند؛ ولی سازمان ثبت اسناد و املاک کشور سردفتران (مدیران دفاتر) را گزینش می‌کند",
        ],
      },
      {
        type: "string",
        fields: [
          "مدارک مورد نیاز برای ازدواج",
          "دفاتر ازدواج و طلاق از نهادهای تخصصی مدنی هستند که بخشی از وظایف اجرایی سازمان ثبت اسناد و املاک کشور را انجام می‌دهند. این دفاتر از نظر مالی مستقل هستند و به‌طور خصوصی اداره می‌شوند؛ ولی سازمان ثبت اسناد و املاک کشور سردفتران (مدیران دفاتر) را گزینش می‌کند",
        ],
      },
      {
        type: "string",
        fields: [
          "ملاحظات مربوط به شرایط ضمن عقد",
          "دفاتر ازدواج و طلاق از نهادهای تخصصی مدنی هستند که بخشی از وظایف اجرایی سازمان ثبت اسناد و املاک کشور را انجام می‌دهند. این دفاتر از نظر مالی مستقل هستند و به‌طور خصوصی اداره می‌شوند؛ ولی سازمان ثبت اسناد و املاک کشور سردفتران (مدیران دفاتر) را گزینش می‌کند",
        ],
      },
    ],
    ratesCount: 0,
    ratesSum: 0,
    averageRate: null,
    author: {
      id: "5f69d0c724d6b1b7c9709646",
      name: "admin",
    },
    metaData: {
      website: "وب سایت",
      working_time: "ساعت کاری",
      address: "آدرس",
      distance: "200",
      phone: "تلفن",
      type: "حقیقی",
    },
  });
  const [openInfo, setOpenInfo] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchResult, setSearchResult] = useState({
    loading: false,
    results: [],
  });
  const [viewport, setViewPort] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    latitude: 35.689003,
    longitude: 51.388606,
    zoom: 14,
    bearing: 0,
    pitch: 0,
    maxZoom: 22,
    minZoom: 10,
  });

  const getCurrentUserPosition = () => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setViewPort({
        ...viewport,
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
      });
    });
  };

  const mapCategoryOptions = [Icon1, Icon2, Icon3, Icon4, Icon5, Icon6, Icon7];

  const categoryEnum = [
    "lbs_mojtame_ghazaie",
    "lbs_dafater_ezdevaj_talagh",
    "lbs_dafater_asnad_rasmi",
    "lbs_dafater_hale_ekhtela",
    "lbs_dafater_khadamat_ghazaie",
    "lbs_dafater_moshavereh_hoghooghi",
    "lbs_maraje_entezami",
  ];

  const [mapCategorySelectedOption, setMapCategorySelectedOption] =
    useState(false);
  const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
  }, [viewport, pinData]);

  useEffect(() => {
    getCurrentUserPosition();
    const dismissGpsInfo = localStorage.getItem("dismissGpsInfo");
    !(dismissGpsInfo !== null && JSON.parse(dismissGpsInfo) === true) &&
      setShowGpsInfo(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loading) {
      mapServiceTimeout && clearTimeout(mapServiceTimeout);

      const timerId = setTimeout(() => {
        const searchParams = {
          byChildren: true,
          distance: metersPerPixel(viewport.latitude, viewport.zoom) * 10000,
          lat: viewport.latitude,
          lng: viewport.longitude,
        };
        getLocationsService(
          mapCategorySelectedOption
            ? { ...searchParams, type: mapCategorySelectedOption }
            : searchParams
        )
          .then((res) => {
            if (res.hasOwnProperty("data")) {
              setLocations(res.data);
            }
          })
          .catch((err) => {
            hasOwnNestedProperty(err, "response.data.message") &&
              err.response.data.message !== undefined &&
              err.response.data.message !== "" &&
              message.error(err.response.data.message);

            console.error(err);
          })
          .finally(() => {
            setLoading(false);
          });
      }, 1000);

      setMapServiceTimeout(timerId);
    }
    // eslint-disable-next-line
  }, [viewport.latitude, viewport.longitude, viewport.zoom]);

  const metersPerPixel = (latitude, zoomLevel) => {
    var earthCircumference = 40075017;
    var latitudeRadians = latitude * (Math.PI / 180);
    return (
      (earthCircumference * Math.cos(latitudeRadians)) /
      Math.pow(2, zoomLevel + pixelMeterSizes[Math.round(zoomLevel)])
    );
  };

  const handleViewportChange = useCallback(
    (newViewport) => setViewPort({ ...newViewport }),
    []
  );

  useEffect(() => {
    if (!openInfo) {
      setPin("");
    }
  }, [openInfo]);

  useEffect(() => {
    if (searchTitle !== "" && searchTitle.length > 0) {
      handleSearch(searchTitle);
    }
    // eslint-disable-next-line
  }, [mapCategorySelectedOption]);

  useEffect(() => {
    let locationsNormalize = getNormalizeObj(locations);
    let pinId = pin;

    if (typeof pin === "object") {
      locationsNormalize[pin.id] = pin;
      pinId = pin.id;
      setPin(pinId);
    }

    if (pinId !== 0 && locationsNormalize && locationsNormalize[pinId]) {
      let pinObj = locationsNormalize[pinId];

      setPinLoading(true);
      getContentService(pinObj.id)
        .then((res) => {
          if (res.hasOwnProperty("data")) {
            setPinData(res.data);
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setPinLoading(false);
        });

      setViewPort({
        ...viewport,
        latitude: pinObj.lat - 0.00015,
        longitude: pinObj.lng,
        zoom: 19,
        transitionDuration: 400,
      });
      setOpenInfo(!openInfo);
    }
    // eslint-disable-next-line
  }, [pin]);

  function handleSearch(title) {
    setSearchTitle(title);
    if (checkValue(title)) {
      setShowSearchResults(true);
      setSearchResult({ ...searchResult, loading: true });
      const searchParams = {
        byChildren: true,
        title: title,
        distance: metersPerPixel(viewport.latitude, viewport.zoom) * 10000,
        lat: viewport.latitude,
        lng: viewport.longitude,
      };
      getLocationsService(
        mapCategorySelectedOption !== false
          ? {
              ...searchParams,
              type: mapCategorySelectedOption,
            }
          : searchParams
      )
        .then((res) => {
          if (res.hasOwnProperty("data")) {
            setSearchResult({
              ...searchResult,
              results: res.data,
              loading: false,
            });
          }
        })
        .catch((err) => {
          hasOwnNestedProperty(err, "response.data.message") &&
            message.error(err.response.data.message);
          setSearchResult({ ...searchResult, loading: false });
        });
    } else {
      setSearchResult({
        ...searchResult,
        results: [],
      });
      setShowSearchResults(false);
    }
  }

  const selectTypeOfLocationHandler = (key) => {
    let value = categoryEnum[key];
    let data = {
      byChildren: true,
      distance: metersPerPixel(viewport.latitude, viewport.zoom) * 10000,
      lat: viewport.latitude,
      lng: viewport.longitude,
      type: value,
    };

    // Disable Selected Type If User Double Touched It
    if (mapCategorySelectedOption === value) {
      delete data.type; // remove type of location from request
      value = false; // unselect locatin type (UI)
    }

    setMapCategorySelectedOption(value);

    if (searchTitle !== "" && searchTitle.length > 0) {
      return;
    }

    setLoading(true);
    setShowSearchResults(false); // hide search result from previous searches
    setSearchResult({ results: [], loading: true });
    getLocationsService(data)
      .then((res) => {
        if (res.hasOwnProperty("data")) {
          setSearchResult({
            ...searchResult,
            results: res.data,
            loading: false,
          });
          setLocations(res.data);
        }
      })
      .catch((err) => {
        hasOwnNestedProperty(err, "response.data.message") &&
          message.error(err.response.data.message);
        setSearchResult({ ...searchResult, loading: false });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const hideSearchResultWhenExaclyMapClicked = (map) => {
    if (
      hasOwnNestedProperty(map, "target.className") &&
      map.target.className === "overlays" // check target class name of clicked item - overlays is default class of map container :(
    ) {
      setShowSearchResults(false); // hide search result if user directly clicked on map layer
    }
  };

  return (
    <>
      <PageContainer
        classNames="lbs"
        headerProps={{
          content: "مکان یاب حقوقی",
          className: "lbs-header pos-fix",
        }}
        // loading={loading}
      >
        <div className="map">
          <div className="search">
            <LBSSearch onSearch={handleSearch} loading={loading} />
            <div className="search-container">
              {showSearchResults && (
                <div className="search-result">
                  <div className="search-result-list">
                    {searchResult.loading ? (
                      <div className="pl-15 pr-15">
                        <Skeleton
                          active={true}
                          avatar={{ shape: "circle" }}
                          paragraph={false}
                        />
                        <Skeleton
                          active={true}
                          avatar={{ shape: "circle" }}
                          paragraph={false}
                          className="mt-15"
                        />
                        <Skeleton
                          active={true}
                          avatar={{ shape: "circle" }}
                          paragraph={false}
                          className="mt-15"
                        />
                        <Skeleton
                          active={true}
                          avatar={{ shape: "circle" }}
                          paragraph={false}
                          className="mt-15"
                        />
                      </div>
                    ) : searchResult.results && searchResult.results.length ? (
                      searchResult.results.map((result, i) => (
                        <div
                          key={result.id}
                          onClick={() => {
                            setPin(result);
                            setShowSearchResults(false);
                          }}
                        >
                          <SearchResults
                            distance=""
                            name={result.title}
                            summary={result.summary}
                            location=""
                            showDivider={i !== searchResult.results.length - 1}
                          />
                        </div>
                      ))
                    ) : (
                      <div className="pl-15 pr-15">داده‌ای وجود ندارد</div>
                    )}
                  </div>
                </div>
              )}
              <div className="searchIconsContainer">
                {mapCategoryOptions.map((value, key) => {
                  return (
                    <img
                      onClick={() => {
                        selectTypeOfLocationHandler(key);
                      }}
                      key={key}
                      className={`${
                        mapCategorySelectedOption === categoryEnum[key]
                          ? "lbs-filter-active"
                          : ""
                      }`}
                      src={value}
                      alt={"icon"}
                    />
                  );
                })}
              </div>
            </div>
          </div>

          <ReactMapGL
            container={viewport}
            onClick={(map) => {
              hideSearchResultWhenExaclyMapClicked(map);
            }}
            ref={mapRef}
            {...viewport}
            onViewportChange={handleViewportChange}
            mapboxApiAccessToken={token}
            mapStyle="mapbox://styles/mapbox/streets-v9?optimize=true"
          >
            <Marker latitude={viewport.latitude} longitude={viewport.longitude}>
              <img
                name="currentLocation"
                src={Pinned}
                alt="pin"
                className="center-pin"
                width="45px"
                height="45px"
              />
            </Marker>
            <Markers
              Locations={locations}
              ActivePin={pin}
              setActivePin={setPin}
              changeMarkerImage={openInfo}
            />

            <div
              className="center-current-location"
              onClick={(event) => getCurrentUserPosition(event)}
            >
              <AimOutlined />
            </div>
          </ReactMapGL>
        </div>
      </PageContainer>
      <SwipeableBottomSheet
        open={openInfo}
        overflowHeight={0}
        onChange={(state) => {
          if (state === false) {
            setOpenInfo(false);
          }
        }}
        overlay={true}
        style={{ zIndex: 99, background: "transparent" }}
        overlayStyle={{ backgroundColor: "transparent" }}
      >
        <MarkerInfo
          showModalHeader={openInfo}
          pinLoading={pinLoading}
          pinData={pinData}
        />
      </SwipeableBottomSheet>
      <BottomSheet
        isOpen={showGpsInfo}
        classNames="archive-lock-popup"
        viewerClassName="archive-lock-popup-viewer right-text"
        height={3000}
      >
        <ShowGpsInfo
          closeBottomSheet={() => {
            setShowGpsInfo(false);
            localStorage.setItem("dismissGpsInfo", "true");
          }}
        />
      </BottomSheet>
    </>
  );
};

export default LBS;
